<script setup lang="ts">
import ProgressFrame from './layout/ProgressFrame.vue';
import VisualFailure from '../components/VisualFailure.vue';
import ButtonPrimary from '@/shared/components/button/ButtonPrimary.vue';
import router from '@/router';
import { useCommissioningDeviceStore } from '../stores/commissioningDeviceStore';

const commissioningDeviceStore = useCommissioningDeviceStore();
const serialNumber = commissioningDeviceStore.serialNumber;

const onTryAgain = () => {
  commissioningDeviceStore.resetRecommissionPrepare();
  router.replace({ name: 'SearchingSolshareRecommissionSetup' });
};
</script>

<template>
  <ProgressFrame pageClass="subsection-page">
    <div class="page-failure-container">
      <VisualFailure>
        <template #title>Failed setting up the SolShare</template>
      </VisualFailure>
      <p class="subtitle">{{ serialNumber }}</p>
      <p>Something went wrong while preparing this SolShare for recommissioning. Please try again.</p>
    </div>
    <div class="end-of-page">
      <ButtonPrimary block @click="onTryAgain" data-tn="try-again-btn">Let's try again</ButtonPrimary>
    </div>
  </ProgressFrame>
</template>

<style lang="less" scoped>
.page-failure-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  margin: @content-side-margin;
}
.subtitle {
  color: @color-secondary;
}
.end-of-page {
  width: 100%;
  padding: @content-side-margin;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
</style>
